import React, { Component } from "react";
import { observer } from "mobx-react";
import moment from "moment";
import Core from "../../Core";

export default observer(
	class ApplicationListRow extends Component {
		onEditClicked() {
			const { application } = this.props;

			const hash = `#application-detail?id=${application.Id}`;
			window.location.hash = hash;
		}

		onDeleteClicked() {
			var result = window.confirm("Delete record?");
			if (result) {
				const { application } = this.props;
				application.store.deleteById(application.Id);
			}
		}

		render() {
			const { application } = this.props;

			return (
				<tr>
					<td>{application.Number}</td>
					<td>{application.Name}</td>
					<td>{moment(application.LastUpdated).format("L LTS")}</td>
					<td>
						<Core.Components.Buttons.Edit onClick={this.onEditClicked.bind(this)} />
					</td>
					<td>
						<Core.Components.Buttons.Delete onClick={this.onDeleteClicked.bind(this)} />
					</td>
				</tr>
			);
		}
	}
);



// WEBPACK FOOTER //
// ./src/Components/ApplicationsList/ApplicationListRow.js